module.exports = __webpack_public_path__ + "img/IT0005204823995.2f3427fd.png";